import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { uploadUserGuideRequestActionCreator } from '../redux/actions/AdminDashboardActions';
import { getAdminDashboardTab } from '../redux/selectors/AdminDashboardSelectors';

export class AdminGenericContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { fileUploadState: '', file: [] };
  }

  fileUploadInputChange = (e) => {
    this.setState({
      fileUploadState: e.target.files[0].name,
      file: e.target.files[0],
    });
  };

  upload = () => {
    this.props.uploadUserGuideRequestActionCreator(this.state.file);
  };

  render() {
    return (
      <div className="admin-dashboard-generic">
        <div className="upload-div">
          User guide:
          <div className="filename-div">{this.state.fileUploadState}</div>
        </div>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label className="custom-file-upload">
          {/* eslint-disable-next-line no-return-assign */}
          <input ref={ref => this.myInput = ref} type="file" onChange={this.fileUploadInputChange} />
          {/* eslint-disable-next-line no-unused-vars */}
          <button onClick={e => this.myInput.click()}>Browse</button>
        </label>
        <button className="upload-button" onClick={this.upload}>Upload</button>
      </div>
    );
  }
}

AdminGenericContainer.propTypes = {
  uploadUserGuideRequestActionCreator: PropTypes.func,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  uploadUserGuideRequestActionCreator,
}, dispatch);

const mapStateToProps = state => ({
  activeTab: getAdminDashboardTab(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminGenericContainer);

